import { render, staticRenderFns } from "./PreparedContentsItemRow.vue?vue&type=template&id=2246dbd9&scoped=true"
import script from "./PreparedContentsItemRow.vue?vue&type=script&lang=js"
export * from "./PreparedContentsItemRow.vue?vue&type=script&lang=js"
import style0 from "./PreparedContentsItemRow.vue?vue&type=style&index=0&id=2246dbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246dbd9",
  null
  
)

export default component.exports